import { Button } from 'antd';
import HTTPService from '../../../utils/makerequest';
import { IPageData } from '../../../interfaces/page-data';
import { useEffect, useRef, useState } from 'react';
import { StateLoader } from '../../../redux/StateLoader';
import { IAuthentication, UserRole } from '../../../interfaces/authentication';
import { Toast } from 'primereact/toast';
import { IAltisDataGridColumns } from '../../../AltisComponent/AltisDataGrid';
import AltisDataGrid from '../../../AltisComponent/AltisDataGrid';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { IInventory } from '../../../interfaces/IItemData';
import MUIDatagrid, { IMUIDataGridColumns } from '../../../AltisComponent/MUIDataGrid';
import { FileExcelOutlined, FilePdfOutlined } from '@ant-design/icons';

const DetailsCounting: React.FunctionComponent<any> = (props) => {
  const { onSetPage } = props;
  const { countingJobId } = useParams<any>();
  const { t } = useTranslation();
  const loader = new StateLoader();
  const userInfo: IAuthentication = loader.loadAuthState();
  const [inventoryData, setInventoryData] = useState<IInventory>();
  const dataGridRef = useRef<any>(null);
  const [loading, setLoading] = useState(false);
  const toast = useRef<any>(null);

  const pageData: IPageData = {
    title: t('countingDetails'),
    loaded: true,
  };

  useEffect(() => {
    dataGridRef.current.GetAllData();
  }, []);

  useEffect(() => {
    onSetPage(pageData);
  }, []);


  const columns: IMUIDataGridColumns[] = [
    ...(userInfo.role == UserRole.AltisAdmin
      ? [{ title: t('Company Name'), key: 'companyName', placeHolder: t('Company Name') }]
      : []),
    { title: t('item-name'), isSorting: true, key: 'inventoryName', placeHolder: t('item-name') },
    { title: t('barcode'), isSorting: true, key: 'customBarcode', placeHolder: t('barcode') },
    { title: t('item_type'), isSorting: true, key: 'typeName', placeHolder: t('item_type') },
    { title: t('item_group'), isSorting: true, key: 'categoryName', placeHolder: t('item_group') },
    { title: t('location'), key: 'locationName', placeHolder: t('Location') },
    { title: t('inventory_status_name'), key: 'inventoryStatusName', placeHolder: t('inventory_status_name') },
  ];
  const CountingDetails = (e) => {
    const filters = e?.filters || {};
    const body = {
      countingJobId: countingJobId,
      filters: {
        sortColumn: e?.sortField || '',
        sortOrder: e?.sortOrder || 'asc',
        pageSize: e?.pageSize || 50,
        page: e?.page || 1,
        ...filters,
      }
    };

    HTTPService.POST(`/CountingJob/CountingDetails`, body)
      .then((response) => {
        if (!response.data) return;
        if (response.status === 200) {
          setInventoryData(response.data);
        } else {
          toast.current?.show({
            severity: 'error',
            summary: t('errors'),
            detail: t(response.data),
            life: 3000
          });
        }
      })
      .catch(error => {
        console.error('Filtreleme Hatası:', error);
        toast.current?.show({
          severity: 'error',
          summary: t('errors'),
          detail: t('error_message'),
          life: 3000
        });
      });
  };


  const excelDownload = () => {
    const data = {
      filtersexcel: inventoryData.data,
      count: inventoryData.count,
      countingJobId: countingJobId,
    };

    HTTPService.POSTblobExcel('/CountingJobInventory/CountingExcelDownloadReport', data)
      .then((response) => {
        if (response.status === 200) {
          toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: t('excelSuccess'),
            life: 3000
          });
        } else if (response.status === 452) {
          toast.current?.show({
            severity: 'error',
            summary: t('error'),
            detail: t('licenceExpiredDate'),
            life: 3000
          });
        } else if (response.status === 453) {
          toast.current?.show({
            severity: 'error',
            summary: t('error'),
            detail: t('licenceNotfound'),
            life: 3000
          });
        } else {
          toast.current?.show({
            severity: 'error',
            summary: t('error'),
            detail: t(response.data),
            life: 3000
          });
        }
      })
      .catch((err) => {
        console.error(err);
        toast.current?.show({
          severity: 'error',
          summary: t('error'),
          detail: t('error_message'),
          life: 3000
        });
      });
  };


  const pdfDownload = () => {
    const data = {
      filtersexcel: inventoryData.data,
      count: inventoryData.count,
      countingJobId: countingJobId,
    };

    setLoading(true);

    HTTPService.POSTblob('/CountingJobInventory/CountingPdfDownloadReport', data)
      .then((response) => {
        setLoading(false);
        if (response.status === 200) {
          toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: t('pdfSuccess'),
            life: 3000
          });
        } else if (response.status === 452) {
          toast.current?.show({
            severity: 'error',
            summary: t('error'),
            detail: t('licenceExpiredDate'),
            life: 3000
          });
        } else if (response.status === 453) {
          toast.current?.show({
            severity: 'error',
            summary: t('error'),
            detail: t('licenceNotfound'),
            life: 3000
          });
        } else {
          toast.current?.show({
            severity: 'error',
            summary: t('error'),
            detail: t(response.data),
            life: 3000
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.current?.show({
          severity: 'error',
          summary: t('error'),
          detail: t('error_message'),
          life: 3000
        });
      });
  };

  return (
    <>
      <Toast ref={toast} />
      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
        <Button
          type="primary"
          onClick={pdfDownload}
          style={{
            height: 64,
            width: 'auto',
            backgroundColor: 'transparent',
            color: '#1890ff',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0 10px',
            border: 'none',
            transition: 'all 0.3s ease',
            cursor: 'pointer'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
            e.currentTarget.style.color = '#40a9ff';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = 'none';
            e.currentTarget.style.color = '#1890ff';
          }}
        >
          <FilePdfOutlined style={{ fontSize: 24 }} />
          <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
            {loading ? t('loading') : t('countingReportGenerate')}
          </span>
          {loading && (
            <div style={{
              position: 'absolute',
              left: '50%',
              top: '50%',
              transform: 'translate(-50%, -50%)',
              border: '4px solid rgba(0, 0, 0, 0.3)',
              borderTop: '4px solid #3498db',
              borderRadius: '50%',
              width: '20px',
              height: '20px',
              animation: 'none',
            }} />
          )}
        </Button>


        <Button
          type="primary"
          onClick={excelDownload}
          style={{
            height: 64,
            width: 'auto',
            backgroundColor: 'transparent',
            color: '#1890ff',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0 10px',
            border: 'none',
            transition: 'all 0.3s ease',
            cursor: 'pointer'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
            e.currentTarget.style.color = '#40a9ff';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = 'none';
            e.currentTarget.style.color = '#1890ff';
          }}
        >
          <FileExcelOutlined style={{ fontSize: 24 }} />
          <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
            {t('countingDetailsExcel')}
          </span>
        </Button>
      </div>

      <div className='row'>
        <div className='col-md-12'>
          <MUIDatagrid
            ref={dataGridRef}
            data={inventoryData?.data}
            total={inventoryData?.count}
            columns={columns}
            filterMode='server'
            defaultPageSize={50}
            onChange={CountingDetails}
          />
        </div>
      </div>
    </>
  );
};

export default DetailsCounting;
